import { DesignSystem } from 'dragonmouse-shared/interfaces';
import * as S from './styles';

interface DsListItemProps {
	item: DesignSystem;
	onClick: () => void;
}

const DsListItem = ({ item, onClick }: DsListItemProps) => {
	const initial = (item.title?.[0] || 'D').toUpperCase();

	return (
		<S.Base onClick={onClick}>
			<S.IconWrapper>{initial}</S.IconWrapper>
			<S.Content>
				<S.Name>{item.title}</S.Name>
			</S.Content>
		</S.Base>
	);
};

export default DsListItem;
